import { Link } from '@tanstack/react-router'
import { Button } from '@trellis/roots/button'
import { Typography } from '@trellis/roots/typography'

export function RouteNotFoundFallback() {
  return (
    <div className="mx-auto max-w-[800px] p-8 text-center">
      <Typography variant="h4" as="h1" className="mb-2">
        Page not found
      </Typography>
      <Typography variant="body" color="muted" className="mb-6">
        The page you're looking for doesn't exist.
      </Typography>
      <Button asChild variant="outline">
        <Link to="/tenants">Back to tenants</Link>
      </Button>
    </div>
  )
}
